import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./grades.css";
import { useState, useRef, useContext } from "react";
import { createGrades, getStandards } from "../../services/functions";
import { MyContext } from "../../provider";

const GradesModal = ({ modal, istoggle }) => {
  const checkRef = useRef();
  const { setGrades } = useContext(MyContext);
  const [payload, setPayload] = useState({ name: "", name_in_voice: "" });
  const setName = (e) => {
    const { name, value } = e.target;
    setPayload({ ...payload, [name]: value });
  };
  const sentData = async () => {
    const ogPayload = {
      ...payload,
      status: checkRef.current.checked ? "public" : "private",
      subsections: [],
    };
    const response = await createGrades(ogPayload);
    if (response.status === 200) {
      const gradesReFetch = await getStandards();
      if (gradesReFetch?.data?.data?.length > 0) {
        setGrades(gradesReFetch.data.data);
      }
    }
    istoggle(!modal);
  };
  return (
    <Modal
      isOpen={modal}
      toggle={() => istoggle(!modal)}
      size="sm"
      className="modal-controller"
    >
      <ModalHeader className="modal-header">Add New Grade </ModalHeader>
      <ModalBody className="modal-body">
        <span className="ps-1">
          <label>Name: </label>
          <input
            type="text"
            className="input-modal"
            name="name"
            onChange={(e) => setName(e)}
          />
        </span>
        <span className="ps-1">
          <label>Name in voice: </label>
          <input
            type="text"
            className="input-modal"
            onChange={(e) => setName(e)}
            name="name_in_voice"
          />
        </span>
        <span className="ps-1">
          <label>Public</label>
          <input type="checkbox" ref={checkRef} />
        </span>
      </ModalBody>
      <ModalFooter className="gades-footer">
        <div className="grades-footer-btn">
          <button onClick={() => sentData()} className="modal-btn-add">
            Add
          </button>
          <button onClick={() => istoggle(!modal)} className="modal-btn-cancel">
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default GradesModal;
